import { NamespaceConsumer, NamespaceShape, withNamespace } from '@ux/namespace-component';
import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider, FormattedMessage } from 'react-intl';
import Link from '@ux/link';
import { TrayMenu } from '@ux/tray-menu';
import { url } from '@ux/header-util';
import { golf } from './enums';

class LoginLogout extends NamespaceConsumer {
  render() {
    const props = this.props;
    let loginUrl = '';
    let logoutUrl = '';
    if (props.urls && props.urls.sso) {
      loginUrl = props.urls.sso.login && url.updateQuery(props.urls.sso.login.href, props.sso);
      logoutUrl = props.urls.sso.logout && url.updateQuery(props.urls.sso.logout.href, props.sso);
    }

    const userIcon = (props.loggedIn && props.isPro) ? 'is-pro' : '';

    const trayName = (
      <div className={ this.namespace('title-text') }>
        { props.displayName }
      </div>
    );

    const trayMenu = (<TrayMenu
      className={ this.namespace('login-logout-tray', 'hidden-sm-down', userIcon) }
      name={ trayName }
      fullwidth={ false }
      showClose={ false }
      data-eid='uxp.hyd.help_header.account_tray.click'>
      <div className={ this.namespace('container') }>
        <div className={ this.namespace('row') }>
          <Link { ...props }
            urlArgs={ props.urlArgs }
            href={ logoutUrl }
            className={ this.namespace('login-logout-out-link') }>
            <FormattedMessage id={ golf.logout } />
          </Link>
        </div>
      </div>
    </TrayMenu>);

    const loginLink = (<div className={ this.namespace('login-logout-link-container', 'hidden-sm-down', userIcon) }>
      <Link { ...props }
        urlArgs={ props.urlArgs }
        href={ loginUrl }
        className={ this.namespace('login-logout-link') }>
        <FormattedMessage id={ golf.login } />
      </Link>
    </div>);

    return (
      <IntlProvider locale={ props.market } messages={ props.messages }>
        { props.loggedIn ? trayMenu : loginLink }
      </IntlProvider>
    );
  }
}

LoginLogout.defaultProps = {
  isPro: false,
  loggedIn: false,
  market: 'en-US'
};

LoginLogout.propTypes = {
  ...NamespaceShape,
  displayName: PropTypes.string,
  isPro: PropTypes.bool,
  loggedIn: PropTypes.bool,
  market: PropTypes.string.isRequired,
  messages: PropTypes.object.isRequired,
  urlArgs: PropTypes.object,
  urls: PropTypes.object.isRequired,
  sso: PropTypes.object
};

export default withNamespace(LoginLogout);
